<template>
    <!--  Persistent because when processing, it's not nice to close the dialog, No No! -->
    <v-dialog
        v-model="addEditConnectionDialogHandle"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="!addEditConnectionProgressBar ? closeAddEditConnectionDialog() : ''"
        @click:outside="!addEditConnectionProgressBar ? closeAddEditConnectionDialog() : ''"
        :persistent="addEditConnectionProgressBar"
    >
        <v-form @submit.prevent.native="addEditAConnection()">

            <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="isAdd ? icons.mdiPlusCircleOutline : icons.mdiPencilCircleOutline" class="mr-3"></v-icon>
                    <div v-text="$gettext('Add Connection')" v-if="isAdd"></div>
                    <div v-text="$gettext('Edit Connection')" v-else-if="isEdit"></div>

                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditConnectionDialog()" v-text="icons.mdiClose"
                            v-show="!showProgressBar && !hasUnsavedChanges"></v-icon>
                    <v-icon @click.native.stop="addEditAConnection()" v-text="icons.mdiContentSave" v-show="!showProgressBar && !hasUnsavedChanges"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-2">
                    <v-container>
                        <v-row v-if="showProgressBar">
                            <v-col>
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    class="mx-3"
                                ></v-progress-circular>
                                <span v-if="addEditConnectionProgressBarMessage" v-text="addEditConnectionProgressBarMessage"></span>
                                <span v-else>{{ $gettext('Just a moment...') }}</span>
                            </v-col>
                        </v-row>
                        <v-row v-else>

                            <!--                            <v-col cols="12" v-if="hasUnsavedChanges" class="pt-0">
                                                            <v-alert color="warning  white&#45;&#45;text" type=warning elevation="4" prominent>

                                                                <v-row>
                                                                    <v-col class="grow">

                                                                        <v-row class="text-h5">
                                                                            <v-col>
                                                                                You have unsaved Changes
                                                                            </v-col>
                                                                        </v-row>
                                                                        <v-row>
                                                                            <v-col>
                                                                                When a connection is edited, it is reconnected, unsaved changes are discarded.
                                                                            </v-col>
                                                                        </v-row>

                                                                        <v-divider class="my-4"></v-divider>

                                                                        <v-row>
                                                                            <v-col>
                                                                                <v-btn rounded @click.native.stop="saveChanges()">Save and Edit</v-btn>
                                                                            </v-col>
                                                                            <v-col>
                                                                                <v-btn rounded>Discard and Edit</v-btn>
                                                                            </v-col>
                                                                        </v-row>

                                                                    </v-col>
                                                                    &lt;!&ndash;                                        <v-col class="shrink">
                                                                                                                <v-btn icon>
                                                                                                                    <v-icon @click.native.stop="showEditHint = false" v-text="icons.mdiCloseCircle"></v-icon>
                                                                                                                </v-btn>
                                                                                                            </v-col>&ndash;&gt;

                                                                </v-row>


                                                            </v-alert>

                                                        </v-col>-->

                            <v-col
                                cols="12"
                            >
                                <v-text-field
                                    :label="$gettext('Connection Name')"
                                    :placeholder="$gettext('Connection Name')"
                                    required
                                    v-model="addEditConnectionName"
                                    :error-messages="addEditConnectionNameErrors"
                                    outlined
                                    @input="$v.addEditConnectionName.$touch()"
                                    @blur="$v.addEditConnectionName.$touch()"
                                    autofocus
                                    clearable
                                ></v-text-field>
                                <v-text-field
                                    :label="$gettext('Server')"
                                    :placeholder="$gettext('Server')"
                                    required
                                    v-model="addEditConnectionServer"
                                    :error-messages="addEditConnectionServerErrors"
                                    outlined
                                    @input="$v.addEditConnectionServer.$touch()"
                                    @blur="$v.addEditConnectionServer.$touch()"
                                    clearable
                                ></v-text-field>
                                <v-text-field
                                    :label="$gettext('Username')"
                                    :placeholder="$gettext('Username')"
                                    required
                                    v-model="addEditConnectionUsername"
                                    :error-messages="addEditConnectionUsernameErrors"
                                    outlined
                                    @input="$v.addEditConnectionUsername.$touch()"
                                    @blur="$v.addEditConnectionUsername.$touch()"

                                    clearable
                                ></v-text-field>

                                <v-text-field
                                    :label="$gettext('Password')"
                                    :placeholder="$gettext('Password')"
                                    required
                                    v-model="addEditConnectionPassword"
                                    :error-messages="addEditConnectionPasswordErrors"
                                    outlined
                                    @input="$v.addEditConnectionPassword.$touch()"
                                    @blur="$v.addEditConnectionPassword.$touch()"
                                    clearable
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary" v-show="!showProgressBar">
                    <v-btn color="primary"
                           @click.native.stop="testConnection()"
                           v-if="!$v.$invalid"
                    >
                        {{ $gettext('Test Connection') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddEditConnectionDialog()" v-text="$gettext('Close')"></v-btn>
                    <v-btn color="primary" type="submit"
                           v-text="isAdd ? $gettext('Add Connection') : $gettext('Save Connection')">
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <snackbar ref="snackbar"></snackbar>
    </v-dialog>
</template>
<script>

import { find } from 'lodash'

import { required } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinGenericFtp from '@/mixins/generic/MixinGenericFtp'
import MixinConfig from '@/mixins/database/MixinConfig'
import { useProgressBarsStore } from '@/stores/ProgressBarStore'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import { useConnectionsStore } from '@/stores/ConnectionsStore'
import { mapWritableState } from 'pinia'

export default {
    components: { Snackbar },
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinGenericFtp, MixinConfig, MixinVuelidate],
    props: {
        connectionsProp: {
            required: true,
            type: Array | Object
        },
        addEditConnectionDialog: {
            required: true,
            type: Boolean,
            default: false
        },
        mode: {
            type: String, // Expected: add/edit
            required: true,
            default: '',
        },

        /**
         * Since this is used for checking the uniqueness, this is filled in for normal edit but also for the edit of invalid connection.
         * It is prefilled conditionally.
         */
        inEditConnectionName: {
            required: false,
            default: ''
        },

        inEditConnectionServer: {
            required: false,
            default: ''
        },

        inEditConnectionUsername: {
            required: false,
            default: ''
        },

        inEditConnectionPassword: {
            required: false,
            default: ''
        },
        inEditConnectionProgressBar: {
            required: false,
            default: false
        },
        inEditConnectionProgressBarMessage: {
            required: false,
            default: false
        },
        /*
        * If typeof following is object i.e. it is set, know that the information received at the time of edit for the connection is invalid (ftp).
        * It can also be put as, presence of this field means that an external connection edit is opened. i.e. the user would have previous successful connection as the current connection. Because, when the system detects that the connection is invalid, it reverts back the connection to the previous connection. However, user is given an opportunity to edit the connection with the error and fix the error. This variable plays a supporting role there.
        *  */
        inEditConnectionCurrentInvalidFtpConnectionDetails: {
            required: false,
            default: false
        },
    },
    data () {
        return {

            addEditConnectionName: '',
            addEditConnectionDialogHandle: '',
            addEditConnectionUsername: '',
            addEditConnectionPassword: '',
            addEditConnectionServer: '',
            showEditHint: true,
            addEditConnectionProgressBar: false,
            addEditConnectionProgressBarMessage: '',
            addEditConnectionCurrentInvalidFtpConnectionDetails: false,

        }
    },
    watch: {
        /**
         * When a popup is closed, the previous entry is left as is.
         * Also, when a popup is opened with other entry the value is not refreshed, with the new one, if we don't have this.
         * @param newVal
         */
        addEditConnectionDialog (newVal) {

            let self = this

            if ( ! newVal) {
                self.resetForm()
            } else {
                self.prefill()
            }

        },

        inEditConnectionProgressBarMessage (newVal) {
            this.addEditConnectionProgressBarMessage = newVal
        },

        inEditConnectionProgressBar (newVal) {
            this.addEditConnectionProgressBar = newVal
        },

    },

    mounted () {

        let self = this

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.addEditConnectionDialogHandle = self.$props.addEditConnectionDialog
        self.addEditConnectionCurrentInvalidFtpConnectionDetails = self.$props.inEditConnectionCurrentInvalidFtpConnectionDetails
        self.addEditConnectionProgressBar = self.$props.inEditConnectionProgressBar
        self.addEditConnectionProgressBarMessage = self.$props.inEditConnectionProgressBarMessage
        self.prefill()

    },

    methods: {

        prefill () {

            let self = this

            if (typeof self.addEditConnectionCurrentInvalidFtpConnectionDetails === 'object') {

                self.addEditConnectionName = self.addEditConnectionCurrentInvalidFtpConnectionDetails.key
                self.addEditConnectionServer = self.addEditConnectionCurrentInvalidFtpConnectionDetails.value.server
                self.addEditConnectionUsername = self.addEditConnectionCurrentInvalidFtpConnectionDetails.value.username
                self.addEditConnectionPassword = self.addEditConnectionCurrentInvalidFtpConnectionDetails.value.password

            } else {

                self.addEditConnectionName = self.$props.inEditConnectionName
                self.addEditConnectionServer = self.$props.inEditConnectionServer
                self.addEditConnectionUsername = self.$props.inEditConnectionUsername
                self.addEditConnectionPassword = self.$props.inEditConnectionPassword

            }

        },

        saveChanges () {

            let self = this
            self.addEditConnectionProgressBarMessage = self.$gettext('Saving your unsaved changes...')
            self.addEditConnectionProgressBar = true

            self.configIdefix3Persist().then(function (response) {
                self.showEditHint = false
            }).catch(function (e) {

            }).finally(function () {
                self.addEditConnectionProgressBar = false
            })

        },

        addEditAConnection () {

            let self = this
            self.$v.$touch()

            if ( ! self.$v.$invalid) {

                if (self.isAdd) {

                    self.connections.push({
                        key: self.addEditConnectionName,
                        value: {
                            server: self.addEditConnectionServer,
                            username: self.addEditConnectionUsername,
                            password: self.addEditConnectionPassword,
                            type: 'FTP'
                        }
                    })

                    self.genericLocalStorageSetItem('connections', self.connections)

                    self.$refs.snackbar.showSnackbar((self.connections && self.connections?.length === 2) ? self.$gettext('Your first connection is created successfully.') : self.$gettext('Connection added successfully')) // 2 Because, by default local is always there.

                    self.closeAddEditConnectionDialog()

                } else {

                    self.$emit('connection-updated', {
                            'connection': {
                                key: self.addEditConnectionName,
                                value: {
                                    server: self.addEditConnectionServer,
                                    username: self.addEditConnectionUsername,
                                    password: self.addEditConnectionPassword,
                                    type: 'FTP'
                                }
                            },
                            'save': false,
                        }
                    )

                }

                // self.closeAddEditConnectionDialog()
                // self.resetForm()

            } else {
                self.$refs.snackbar.showSnackbar(self.$gettext('Please resolve the form errors'), 'error')
            }

        },
        testConnection () {
            let self = this
            // self.$refs.snackbar.showSnackbar('Testing your connection...')
            self.addEditConnectionProgressBarMessage = self.$gettextInterpolate(self.$gettext('Connecting to %{ connectionName } and validating your connection. Just a moment...'), { connectionName: self.addEditConnectionServer })
            self.addEditConnectionProgressBar = true

            self.genericValidateFtpConnection(self.addEditConnectionServer, self.addEditConnectionUsername, self.addEditConnectionPassword)
                .then(function (response) {

                    if (response && response.status) {
                        self.$refs.snackbar.showSnackbar(self.$gettext('The connection was successful'))
                    } else {

                        if (response.hasOwnProperty('errorCode') && response.errorCode && response.errorCode.length > 0) {

                            self.$refs.snackbar.showSnackbar(response.errorCode, 'error')

                            switch (response.errorCode) {

                                case 'connection_failed': {
                                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Sorry! we could not connect to %{ hostname }'), { hostname: self.addEditConnectionServer }), 'error')
                                    break
                                }

                                case 'invalid_credentials': {
                                    self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! It appears you\'ve provided an incorrect ftp credentials.'), 'error')
                                    break
                                }

                                case 'default': {
                                    self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection'), 'error')
                                    break
                                }

                            }

                        } else {
                            self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection (2)'), 'error')
                        }

                    }
                }).catch(function (error) {
                self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection'), 'error')
            }).finally(function () {
                self.addEditConnectionProgressBar = false
            })

        },
        closeAddEditConnectionDialog () {
            let self = this
            self.$emit('close-add-edit-connection-dialog', 'addEditConnectionDialog')
        },
        resetForm () {
            let self = this
            self.addEditConnectionName = ''
            self.addEditConnectionServer = ''
            self.addEditConnectionUsername = ''
            self.addEditConnectionPassword = ''
            self.$v.$reset()
        },
    },
    computed: {

        ...mapWritableState(useConnectionsStore, {
            connections: 'connections',
        }),

        isAdd () {
            return this.$props.mode === 'add'
        },
        isEdit () {
            return this.$props.mode === 'edit'
        },

        showProgressBar () {

            let self = this
            const progressBarsStore = useProgressBarsStore()

            if (self.addEditConnectionProgressBar || progressBarsStore.getSaveProgressBar()) {
                return true
            }

            return false

        },

        hasUnsavedChanges () {
            return (this.isEdit && this.showEditHint && this.configHasUnsavedChanges()['status'])
        },

        addEditConnectionNameErrors () {
            const errors = []
            if ( ! this.$v.addEditConnectionName.$dirty) return errors
            ! this.$v.addEditConnectionName.required && errors.push(this.$gettext('Connection name is required.'))
            ! this.$v.addEditConnectionName.isUnique && errors.push(this.$gettext('We already have a connection with this name.'))
            return errors
        },

        addEditConnectionServerErrors () {
            const errors = []
            if ( ! this.$v.addEditConnectionServer.$dirty) return errors
            ! this.$v.addEditConnectionServer.required && errors.push(this.$gettext('Server is required.'))
            return errors
        },

        addEditConnectionUsernameErrors () {
            const errors = []
            if ( ! this.$v.addEditConnectionUsername.$dirty) return errors
            ! this.$v.addEditConnectionName.required && errors.push(this.$gettext('Username name is required.'))
            return errors
        },

        addEditConnectionPasswordErrors () {
            const errors = []
            if ( ! this.$v.addEditConnectionPassword.$dirty) return errors
            ! this.$v.addEditConnectionPassword.required && errors.push(this.$gettext('Password is required.'))
            return errors
        },

    },
    validations: {
        addEditConnectionName: {
            required,
            async isUnique (value, vm) {
                let allowedValue = vm.mode === 'edit' ? vm.$props.inEditConnectionName : null
                return await this.vuelidateIsUniqueForKeyValueType(value, this.$props.connectionsProp, allowedValue)
            }
        },

        addEditConnectionServer: {
            required,
        },
        addEditConnectionUsername: {
            required,
        },
        addEditConnectionPassword: {
            required,
        },
    }

}
</script>

<style type="text/scss">
.add-connection-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>
